export enum TipoMensagem {
    SIMPLES = "S",
    RESPOSTA = "R",
    HTML = "H",
    LINK = "L",
    FACEBOOK = "F",
    IMAGEM = "I",
    ARQUIVO = "A"
} 

export enum OrigemMensagem {
    DIREITA = "R",
    ESQUERDA = "L"
}

interface MensagemOrigem {
    idMensagemUsuario: number
    tipo: TipoMensagem,
    idUsuarioOrigem: number,
    idUsuarioDestino: number,
    codUsuario?: number,
    codEmpresa?: number,
    mensagem: string,
    statusMensagemRecebida: boolean,
    statusMensagemLida: boolean,
    origem: OrigemMensagem,
    data: string,
    hora: string,
    pendente?: boolean
}

interface MensagemSimplesContato extends MensagemOrigem {
    idContato: number
}

interface MensagemSimplesArea extends MensagemOrigem {
    idArea: number
}

interface MensagemResposta extends MensagemOrigem {
    
}

export interface ArquivoMensagem {
    mime: string,
    nome: string,
    link: string
}

export interface Mensagem {
    idMensagemUsuario: number,
    tipo: TipoMensagem,
    idContato?: number, //não vem nas mensagens quando o usuário loga, mas vem quando ele recebe uma nova mensagem
    idArea?: number, //não vem nas mensagens quando o usuário loga, mas vem quando ele recebe uma nova mensagem
    idEnvio?: number,
    idUsuarioOrigem: number,
    idUsuarioDestino: number,
    nomeUsuario?: string,
    mensagem: string,
    mensagemResumo?: string,
    mensagemTexto?: string,
    link?: string,
    hashLogotipo?: string,
    hashHTML?: string,
    labelLink?: string,
    textoTipoMensagem?: string,
    statusMensagemRecebida: boolean,
    statusMensagemLida: boolean,
    origem: OrigemMensagem,
    arquivo?: ArquivoMensagem,
    podeSerRespondida: boolean,
    data: string,
    falhaNoEnvio?: boolean,
    hora: string,
    dataHora?: number,
    pendente?: boolean
}


// WEBPACK FOOTER //
// ./src/models/mensagem.ts